import { Box, Button, styled } from "@mui/material";
import { Colors } from "../../Styles/colors";

export const StyledButton = styled(Button)(({theme})=>({
  width:'50%',
  alignSelf:'center',
  color:`white`,
  backgroundColor:`${Colors.primary.orange}`,
  fontSize:'16px',
  '&:hover': {
    backgroundColor: `${Colors.primary.blue}`,
  },
}));

export const FlexBoxSpaceBetween = styled(Box)(()=>({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  flexWrap: 'wrap'
}))